import { useNavigate } from "react-router-dom";
import { FaCheck, FaXmark } from "react-icons/fa6";
import Button from "../components/common/Button";
import ReservationInfo from "../components/ReservationInfo";
import { isTimeBeforeNow } from "../utils/time";
import { ConfigResponse } from "../types";
import { ReservationInfoResponse } from "../types/reservation";
import { ROUTE_PATH, STORAGE_KEY } from "../constants";
import ReservationHeader from "../components/ReservationHeader";
import HotelImage from "../components/HotelImage";
import RoomName from "../components/RoomName";
import { useTranslation } from "react-i18next";
import BookingButton from "../components/BookingButton";
import { useEffect } from "react";
import useLocation from "../hooks/useLocation";
import LocationCheck from "../components/LocationCheck";
import { formatTime } from "../utils/format";

interface Props {
  config: ConfigResponse;
  reservationInfo: ReservationInfoResponse;
}

const DueInPage = ({
  config: { latitude, longitude, radius, checkin_enable_time, hotel_image, is_location },
  reservationInfo
}: Props) => {
  const { hotel_name, room_no, guest_name, check_in_date } = reservationInfo;

  const navigate = useNavigate();
  const { t } = useTranslation();

  const { isValid, isLocationLoading, invalidMessage, handleCheckLocation } = useLocation({
    latitude,
    longitude,
    radius
  });

  const isCheckTime = isTimeBeforeNow(check_in_date, checkin_enable_time);
  const isBookingButton = localStorage.getItem(STORAGE_KEY.SKIP_KAKAO) === "true";
  const isLocationValid = is_location ? isValid : true;

  const handleNavigation = () => {
    navigate(ROUTE_PATH.POLICY_AGREE);
  };

  useEffect(() => {
    if (is_location) handleCheckLocation();
  }, [is_location]);

  return (
    <div className="flex flex-col gap-y-6">
      <ReservationHeader hotelName={hotel_name} guestName={guest_name} />
      <HotelImage hotelImage={hotel_image} />
      {room_no && <RoomName roomName={room_no} />}
      <ReservationInfo reservationInfo={reservationInfo} />
      <section className="flex flex-col gap-y-3">
        {is_location && (
          <LocationCheck
            isValid={isValid}
            isLoading={isLocationLoading}
            invalidMessage={invalidMessage}
            handleCheckLocation={handleCheckLocation}
          />
        )}
        <div className={`flex gap-x-2 text-sm ${isCheckTime ? "text-[#22c55e]" : "text-red-500"}`}>
          {isCheckTime ? <FaCheck className="mt-0.5" /> : <FaXmark className="mt-0.5" />}
          {t("checkin_available_time", { time: formatTime(checkin_enable_time) })}
        </div>
      </section>

      <div className="flex flex-col gap-y-3">
        <Button onClick={handleNavigation} disabled={!isCheckTime || !isLocationValid}>
          {t("checkin")}
        </Button>
        {isBookingButton && <BookingButton />}
      </div>
    </div>
  );
};

export default DueInPage;
